import React from 'react'
import GeoentityFuelCard from './GeoentityFuelCard'
import s from './GeoentityFuelListItem.less'
import { useSelector } from 'react-redux'
import {} from '../search/filters/filters.constants'
import { DEFAULT_FUEL_ID } from '../../store/geoentity/geoentity.constants'
import { isPE } from '../Device'
import { selectCurrentFuelFilterIdWithoutFallback } from '../../store/geoentity/fuels.selectors'

const GeoentityFuelCards = ({ poi }) => {
  const { additionalInfo = {} } = poi
  const { fuels } = additionalInfo

  const displayNumber = isPE() ? 2 : 3

  const currentFuelFilterId = useSelector(selectCurrentFuelFilterIdWithoutFallback)
  const shouldApplyFilterStyle = Boolean(currentFuelFilterId)

  const currentFuelId = currentFuelFilterId ?? DEFAULT_FUEL_ID
  const firstFuelToDisplay = fuels.find(fuel => fuel.id === currentFuelId)
  const fuelsToDisplay = [firstFuelToDisplay].concat(fuels.filter(fuel => fuel.id !== currentFuelId))
  const hiddenFuelsLength = fuelsToDisplay.length > displayNumber ? fuelsToDisplay.length - displayNumber : 0

  return (
    <div className={s.gasContainer}>
      {fuelsToDisplay.slice(0, displayNumber).map((fuel, index) => (
        <GeoentityFuelCard key={fuel.id} fuel={fuel} opacity={shouldApplyFilterStyle && index !== 0} />
      ))}
      {hiddenFuelsLength > 0 && <span className={s.moreFuelsNumber}>+{hiddenFuelsLength}</span>}
    </div>
  )
}

export default GeoentityFuelCards
